import { NO, UIBaseButton, UIObject, YES } from "uicore-ts"
import { CBCheckbox } from "./CBCheckbox"


export type SelectableView = (UIBaseButton | CBCheckbox) & { selected: boolean }


export class CBButtonGroup extends UIObject {
    
    selectedButton?: SelectableView
    readonly buttonsMap: Record<string, SelectableView>
    
    get value() {
        
        this.selectedButton = this.selectedButton ?? Object.values(this.buttonsMap).find(
            (button: SelectableView) => button.selected
        )
        
        const result = Object.entries(this.buttonsMap).find(
            ([_valueKey, button]) => button == this.selectedButton
        )?.[0]!
        
        return result
        
    }
    
    set value(value: string) {
        for (const button of Object.values(this.buttonsMap)) {
            button.selected = NO
        }
        this.selectedButton = undefined
        if (value && this.buttonsMap[value]) {
            this.buttonsMap[value].selected = YES
            this.selectedButton = this.buttonsMap[value]
            // this.selectionDidChange(sender)
        }
    }
    
    
    constructor(buttons: Record<string, SelectableView> | SelectableView[]) {
        
        super()
        
        let buttonsObject: Record<string, SelectableView>
        if (buttons instanceof Array) {
            buttonsObject = Object.fromEntries(buttons.map((button, index) => [index + "", button]))
        }
        else {
            buttonsObject = buttons
        }
        this.buttonsMap = buttonsObject
        
        Object.entries(this.buttonsMap).forEach(([value, button]) => {
            
            button.controlEventTargetAccumulator.PrimaryActionTriggered = (
                sender: SelectableView,
                event?: Event
            ) => {
                
                if (this.selectedButton == sender) {
                    return
                }
                
                // Select only the correct button
                for (const buttonToDeselect of Object.values(this.buttonsMap)) {
                    buttonToDeselect.selected = NO
                }
                sender.selected = YES
                
                this.selectedButton = sender
                
                this.selectionDidChange(sender, value)
                
            }
            
        })
        
    }
    
    
    selectionDidChange(selectedButton: SelectableView, value: string | undefined) {
        
        // Override this
        console.log("Selection changed to ", selectedButton)
        
    }
    
    
}






